import React from "react";
import { motion } from "framer-motion";

const EASE = [0.76, 0, 0.24, 1];

/**
 * ClosingManifesto - a minimalist, centered editorial statement placed
 * immediately above the footer. Pure black background, soft white body
 * copy set in Cormorant Garamond italic, with a subtle gold accent.
 */
export const ClosingManifesto = () => {
  return (
    <section
      id="manifesto-closing"
      data-testid="closing-manifesto-section"
      className="relative bg-[color:var(--bt-bg)] px-6 md:px-10 py-48 md:py-72"
    >
      <div className="mx-auto max-w-[900px] text-center flex flex-col items-center">
        {/* Hairline ornament */}
        <motion.div
          initial={{ scaleX: 0 }}
          whileInView={{ scaleX: 1 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 1.1, ease: EASE }}
          className="h-px w-16 bg-[color:var(--bt-gold)] mb-10 origin-center"
        />

        <motion.span
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8, delay: 0.15 }}
          data-testid="closing-manifesto-eyebrow"
          className="text-[11px] tracking-widest-brand uppercase text-[color:var(--bt-gold)] mb-10"
        >
          The Manifesto
        </motion.span>

        <motion.p
          data-testid="closing-manifesto-body"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 1.1, delay: 0.25, ease: EASE }}
          className="font-serif-display italic font-light text-[color:var(--bt-ink)]/90 text-2xl md:text-4xl leading-[1.28] tracking-tight"
        >
          The Season is more than a list of dates. It is a{" "}
          <span className="text-[color:var(--bt-gold)] not-italic font-normal">
            curated authority
          </span>{" "}
          for the formal calendar - a definitive guide for those who value
          tradition, heritage, and the art of the evening. We don't just
          publish events;{" "}
          <span className="text-[color:var(--bt-gold)] not-italic font-normal">
            we curate the social calendar.
          </span>
        </motion.p>

        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.9, delay: 0.9 }}
          className="mt-14 flex items-center gap-4 text-[10px] tracking-widest-brand uppercase text-[color:var(--bt-ink-dim)]"
        >
          <span className="w-10 h-px bg-[color:var(--bt-gold-line)]" />
          The Editors, London
          <span className="w-10 h-px bg-[color:var(--bt-gold-line)]" />
        </motion.div>

        {/* Second hairline ornament */}
        <motion.div
          initial={{ scaleX: 0 }}
          whileInView={{ scaleX: 1 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 1.1, delay: 0.35, ease: EASE }}
          className="h-px w-16 bg-[color:var(--bt-gold)] mt-14 origin-center"
        />
      </div>
    </section>
  );
};

export default ClosingManifesto;
